// extracted by mini-css-extract-plugin
export default {"header":"header_header__VNf5t","body":"header_body__A9jve","gallery":"header_gallery__JPuhd"};